import { useTranslation } from "react-i18next"

import { Folder, Plus } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { EmptyState } from "@/components/ui/empty-state"

type ProjectEmptyStateProps = {
  onCreateProject?: () => void
}

export function ProjectEmptyState({ onCreateProject }: ProjectEmptyStateProps) {
  const { t } = useTranslation()

  return (
    <EmptyState
      className="h-full"
      icon={Folder}
      title={t("projects.emptyState.title", { defaultValue: "No Project Selected" })}
      description={t("projects.emptyState.description", {
        defaultValue: "Select or create a project to start working with AI conversations.",
      })}
      primaryAction={
        onCreateProject ? (
          <Button onClick={onCreateProject}>
            <Plus className="mr-2 size-4" />
            {t("projects.actions.create", { defaultValue: "Create Project" })}
          </Button>
        ) : undefined
      }
    />
  )
}
